export default __webpack_public_path__ + "static/media/nifty50-whythisshift-graph2.d2546da4.jpg";